exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j-vxe-popover-title .j-vxe-popover-title-close[data-v-5d7853fc] {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 31px;\n  height: 31px;\n  text-align: center;\n  line-height: 31px;\n  color: rgba(0, 0, 0, 0.45);\n  cursor: pointer;\n  -webkit-transition: color 300ms;\n  transition: color 300ms;\n}\n.j-vxe-popover-title .j-vxe-popover-title-close[data-v-5d7853fc]:hover {\n  color: rgba(0, 0, 0, 0.8);\n}\n.j-vxe-popover-div[data-v-5d7853fc] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 31px;\n  z-index: -1;\n}\n", ""]);

// exports
